import { ENV_JS } from "../utils/env_module"

const callpy_global = {};
callpy_global.modules = {};
callpy_global.php_server = ENV_JS.CALLPY_PHP_SERVER;
callpy_global.callpy_domain = ENV_JS.CALLPY_SERVER;
let m_callpy
if(!window.callpy_global) window.callpy_global = callpy_global

function register_module(m_name) {
    var result = false;
    var module = null;
    /* asdasd */
    try
    {
        module = eval(m_name);
    }
    catch (e)
    {
        m_callpy?.m_logger?.error("Global Error:", e);
    }

    if (typeof module == "function")
    {
        var result = new module();

        if (!callpy_global.modules[result.module_name])
        {
            callpy_global.modules[result.module_name] = result;

            m_callpy.m_logger.log("Module Registred : " + result.module_name)
        }
        else
        {
            m_callpy.m_logger.warn("Module " + m_name + " already registred!")
        }
    }
    else
    {
        m_callpy?.m_logger?.warn("Module " + m_name + " does not exist!")
    }
    return result;
}

if(!m_callpy) {
  const m_callpy = register_module("CCallpy");
  window.m_callpy = m_callpy
}

